import { Box, List, ListItem, ListItemText, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import CustomDivider from '../shared/utils/CustomDivider'
import { Page_Padding } from '../shared/constants'
import { useGetContentDetail } from '../assets/nodeApi/getApi/ContentGetApi'
import { usePageContentWithMeta } from '../shared/hook/usePageContentWithMeta'

const ShippingPolicy = ({ onLoadingChange }) => {
    const { data: Detail, isLoading } = usePageContentWithMeta("SHIPPING_POLICY");

    useEffect(() => {
        onLoadingChange(isLoading);
    }, [isLoading, onLoadingChange]);

    if (isLoading) return null;
    return (
        // <Box sx={{ padding:Page_Padding }}>
        //     <Typography variant='h1'>Shipping Policy</Typography>
        //     <CustomDivider size={20} />
        //     <Typography variant='body2'>
        //         At MySkill Club(hereinafter referred as we/our), We are
        //         committed to providing a smooth and efficient shipping
        //         experience for all our customers. This policy outlines how
        //         we handle orders from the time they are placed to the
        //         time they are delivered.
        //     </Typography>
        //     <CustomDivider size={20} />
        //     <Typography variant='h5' fontWeight={"bold"}>Shipping Methods and Costs:</Typography>
        //     <CustomDivider size={10} />
        //     <List component={"ol"} sx={{ listStyleType: 'decimal', pl: 2 }}>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={<Typography variant='body2'>
        //                 Standard Shipping:
        //                 We offer standard shipping within India, with an
        //                 estimated delivery time of 21 business days. The cost for
        //                 standard shipping is subject to market price.
        //             </Typography>} />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={<Typography variant='body2'>
        //                 Express Shipping:
        //                 For faster delivery, we offer express shipping with an
        //                 estimated delivery time of 7 business days. The cost for
        //                 express shipping is subject to market price.
        //             </Typography>} />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                     International Shipping:
        //                     We also ship internationally to [List of
        //                     Countries/Regions]. Please note that international
        //                     shipping costs and delivery times may vary depending on
        //                     the destination country. You can calculate shipping costs
        //                     during checkout.
        //                 </Typography>
        //             } />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                     Shipping Carrier:
        //                     We typically use [List of Shipping Carriers] for our
        //                     shipments.
        //                 </Typography>
        //             } />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                     Tracking Information:
        //                     Once your order ships, you will receive a tracking number
        //                     via email, allowing you to monitor the progress of your
        //                     shipment.
        //                 </Typography>
        //             } />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                     Order Processing Time:
        //                     Orders are typically processed within 7 business days of
        //                     receipt.
        //                     During peak seasons or holidays, processing times may
        //                     be slightly longer.
        //                     We will notify you if there is any unexpected delay in
        //                     processing your order.
        //                 </Typography>
        //             } />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                   Shipping Restrictions:
        //             We do not ship to [List of Restrictions, e.g., P.O. Boxes,
        //             certain countries].
        //             We reserve the right to refuse shipping to any address if
        //             we deem it unsafe or unreliable.
        //                 </Typography>
        //             } />

        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                       Lost or Damaged Packages:
        //             If your package is lost or damaged during transit, please
        //             contact us immediately at support@myskill.club
        //             We will work with you to resolve the issue and will either
        //             reship the order or issue a refund, depending on the
        //             circumstances.
        //                 </Typography>
        //             } />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                   Returns and Exchanges:
        //             Please refer to https:myskill.club/retrurns for information
        //             on returns and exchanges.
        //             We want you to be happy with your purchase, and we will
        //             do our best to accommodate your needs.
        //                 </Typography>
        //             } />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                        International Shipping Considerations:
        //             Customs and Import Duties:
        //             Customers are responsible for any customs duties, taxes,
        //             and other fees that may be imposed by the destination
        //             country.
        //                 </Typography>
        //             } />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                      Currency Conversion:
        //             International shipping costs are displayed in [Currency].
        //             The final cost may vary slightly depending on the
        //             currency exchange rate at the time of payment.
        //                 </Typography>
        //             } />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                       Shipping Delays:
        //             International shipping may be subject to delays due to
        //             customs clearance or other factors outside of our control.
        //                 </Typography>
        //             } />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                 Contact Information:
        //             If you have any questions about our shipping policy,
        //             please contact us at support@myskill.club
        //                 </Typography>
        //             } />
        //         </ListItem>
        //         <ListItem component={"li"} sx={{ display: 'list-item' }}>
        //             <ListItemText primary={
        //                 <Typography variant='body2'>
        //                          Policy Updates:
        //             We reserve the right to update this shipping policy at any
        //             time. Please check this page periodically for any changes.
        //             Thank you for choosing us!
        //                 </Typography>
        //             } />
        //         </ListItem>

        //     </List>
















        // </Box>
        <>
            <Box sx={{ padding: Page_Padding }}>
                <div dangerouslySetInnerHTML={{ __html: Detail?.content?.[0]?.data?.detail }} />

            </Box>

        </>






    )
}

export default ShippingPolicy